import { useContext, useState, useMemo } from "react";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import WorkFlowFormModalCrm from "./WorkFlowFormModalCrm";
import { generateEditInitialValues, transformFields, transformResponse } from "./utils/function";
import { replaceLabelValueObjects } from "utils/functions/function";

const EditFormCrm = ({ isOpen, setIsOpen, initialValues, handleGetData }: any) => {
  const { toastNotify, getDefaultWorkFlow, workFlowData, getUsersWorkFlows } =
    useContext(AppContext);
  const [deletedApprovals, setDeletedApproavals] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  const submitForm = async (valuess: any, resetForm: any) => {
    try {
      const transformedValuesResponse = transformResponse(valuess);
      const transformedValues: any = Array.isArray(transformedValuesResponse) ? transformedValuesResponse[0] : transformedValuesResponse;

      let obj: any = {
        deletedApprovals: deletedApprovals,
        values: {
          ...replaceLabelValueObjects(valuess),
          ...replaceLabelValueObjects(transformedValues),
        },
        workFlowName: transformedValues.workFlowName || valuess.workFlowName,
        flowName: valuess.flowName,
        processName: valuess.processName?.value || valuess.processName,
        processType: valuess.processType?.value || valuess.processType,
        levels: valuess.levels,
        identifier: valuess.identifier,
        id: initialValues._id,
        costs: transformedValues.costs,
      };
      setLoading(true);
      if (valuess) {
        const response: any = await appRequest("workflow", "update", obj);
        if (response.status === "success") {
          toastNotify({
            title: `CRM Workflow Updated successfully`,
            message: response.message || "Something went wrong.",
            type: "success",
          });
          handleGetData();
          resetForm();
          handleCloseModal();
          if (valuess._id === workFlowData?._id) {
            getDefaultWorkFlow();
            getUsersWorkFlows();
          }
        } else {
          toastNotify({
            title: `Error updating the workflow.`,
            message: response.message || "Something went wrong.",
            type: "error",
          });
        }
      }
    } catch (err: any) {
      console.log(err)
      toastNotify({
        title: `Error updating the workflow.`,
        message: err.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const memoizedInitialValues = useMemo(() => {
    if (!initialValues) return null;
    return generateEditInitialValues(
      {
        ...initialValues,
        ...initialValues.values
      },
      transformFields(initialValues?.schema?.fields || [])
    );
  }, [initialValues]);

  return (
    <>
      <WorkFlowFormModalCrm
        setDeletedApproavals={setDeletedApproavals}
        type="edit"
        isOpen={isOpen}
        onClose={handleCloseModal}
        initialValues={memoizedInitialValues}
        loading={loading}
        submitForm={submitForm}
        showError={showError}
        setShowError={setShowError}
      />
    </>
  );
};

export default EditFormCrm;
